import React, { useEffect, useState } from "react";
import { Badge, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HomeIcon from "@mui/icons-material/Home";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonIcon from "@mui/icons-material/Person";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { t } from "i18next";
import axios from "axios";
import "../css/mobileScreens.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FCM_TOKEN, getAuthMobile, getGustAuthMobile, sendNotificationFirebaseRes, setMobileBackColor, setMobileCardColor, setMobileTextColor } from "../utility";
import { LoginOutlined, LoginRounded, ShoppingCart } from "@mui/icons-material";
import Pusher from "pusher-js";
import addNotification from "react-push-notification";
import noImageAvailable from "../images/No_Image_Available.jpg";
import LoginComponent from "./mobile screen/mobileComponents/loginComponent";
const BottomNavBar = ({ qrName, qr, saveCartState }) => {

    useEffect(() => {
        const fetchBasketItems = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API}/basket-items?menu_code=${qr}&token=${localStorage.getItem("gustToken")}`,
                    {
                        headers: {
                            localization: localStorage.getItem("lang"),
                        },
                    }
                );
                if (response?.data?.success) {
                    setBasketItems(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching basket items:", error);
            }
        };

        fetchBasketItems();
    }, [qr]);

    useEffect(() => {
        const pusher = new Pusher("ae14bac927c237af424c", {
            cluster: "mt1",
            auth: getGustAuthMobile(),
        });
        const channel = pusher.subscribe(
            `customer_notifications.${localStorage.getItem("gustToken")}`
        );
        channel.bind("App\\Events\\NotificationRespond", (data) => {
            addNotification({
                title: data.title,
                message: data.message,
                duration: 8000,
                icon: detailsData?.logo || noImageAvailable,
                native: true,
                onClick: () => console.log("notification received"),
            });

        });

        return () => {
            pusher.unsubscribe("customer_notifications");
            pusher.disconnect();
        };
    }, []);


    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [params] = useSearchParams();
    const [detailsData] = useState(JSON.parse(localStorage.getItem("tree_data")).details || []);
    const [allTreeData, setAllTreeData] = useState(JSON.parse(localStorage.getItem("tree_data")) || []);
    const navigate = useNavigate();
    const location = useLocation();

    const handleOpenDialog = () => setIsDialogOpen(true);
    const handleCloseDialog = () => setIsDialogOpen(false);
    const [basketItems, setBasketItems] = useState([]);

    const [loginDialogOpen, setLoginDialogOpen] = useState(false);


    const shouldMobileHideNavbar = /\/[^/]+\/(menus|items)$/.test(location.pathname);
    if (shouldMobileHideNavbar) {
        return null;
    }


    const handleNavigation = (path) => navigate(path);

    const handleSendNotification = async (title, body) => {
        try {
            const sendNotificationRes = await axios.post(
                `${process.env.REACT_APP_API}/general-notification`,
                {
                    venue_id: detailsData?.venue_id,
                    title: title || "",
                    message: body || "",
                    table: params.get("t") || "",
                }
            );


            const sendNotificationFirebase = await sendNotificationFirebaseRes(detailsData, title || "", body || "", "notifications");

            if (sendNotificationRes?.data?.success && sendNotificationFirebase?.data?.success) {
                toast.success(
                    <div className="alignByLang">
                        {t("Your notification sent successfully")}
                    </div>
                );
            } else {

                toast.error(
                    <div className="alignByLang">
                        {t("Error while sending the notification.")}
                    </div>
                );
            }
        } catch (error) {

            toast.error(
                <div className="alignByLang">
                    {t("Error while sending the notification.") + " " + error.message}
                </div>
            );
        }
    };


    const handleFeedBack = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(
            `/${qrName}/${qr}/feedback?section=${params.get("section")}&t=${params.get("t")}&lang=${params.get("lang")}`
        );
    };
    const handleFavorites = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(
            `/${qrName}/${qr}/favorites?section=${params.get("section")}&t=${params.get("t")}&lang=${params.get("lang")}`
        );
    };

    const handleClickCart = () => {
        if (basketItems.items?.length > 0) {
            navigate(
                `/${qrName}/${qr}/cart?section=${params.get(
                    "section"
                )}&t=${params.get("t")}&lang=${params.get("lang")}`
            )
        } else {
            toast.success(
                <div className="alignByLang sub-font">
                    {t("Your Cart is empty")}
                </div>
            );
        }

    };


    const handleHome = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(`/${qrName}/${qr}/sections?section=0&lang=${params.get("lang")}&t=${params.get("t")}`);
    };

    const handleProfile = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        navigate(`/${qrName}/${qr}/profile?lang=${localStorage.getItem("lang")}&t=${params.get("t")}`);
    };

    const handleLogin = async () => {

    };

    const handleLogout = async () => {
        if (saveCartState) {
            await saveCartState();
        }
        await localStorage.setItem("mobileLoginToken", "");
        navigate(`/${qrName}/${qr}/menus?lang=${localStorage.getItem("lang")}&t=${params.get("t")}`);
    };

    const handleOrders = () => {
        navigate(
            `/${qrName}/${qr}/orders?section=${params.get("section")}&t=${params.get("t")}&lang=${params.get("lang")}`
        );
    };


    const getBasketItems = async () => {
        const basketItems = await axios.get(
            `${process.env.REACT_APP_API
            }/basket-items?menu_code=${qr}&token=${localStorage.getItem(
                "gustToken"
            )}`,
            {
                headers: {
                    localization: localStorage.getItem("lang"),
                },
            }
        );

        if (basketItems?.data?.success) {
            setBasketItems(basketItems?.data?.data)
        }
    }

    const handleOpenLoginDialog = (is_from_order) => {
        setLoginDialogOpen(true);
    };

    const handleCloseLoginDialog = () => {
        setLoginDialogOpen(false);
    };

    const handleVerificationSuccess = (token) => {
        if (token) {
            localStorage.setItem("mobileLoginToken", token || "");

        }
    };




    return (
        !allTreeData?.details?.order_ability && !allTreeData?.details?.whatsapp ? true :
            <div>
                <ToastContainer />
                <div className="bottom-nav" style={{ backgroundColor: setMobileCardColor() }}>
                    <button className="nav-item" onClick={() => handleHome()}>
                        <HomeIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                        <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Home")}</span>
                    </button>

                    <button className="nav-item" onClick={() => handleFavorites()}>
                        <FavoriteIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                        <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Favorites")}</span>
                    </button>



                    {JSON.parse(params.get("t")) && (
                        <button className="nav-item" onClick={handleOpenDialog}>
                            <HelpOutlineIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                            <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Helper")}</span>
                        </button>
                    )}



                    <button disabled={!allTreeData?.details?.is_available} className="nav-item" onClick={() => handleClickCart()}>
                        <div>
                            <Badge
                                badgeContent={
                                    <span
                                        style={{
                                            backgroundColor: "#D92D20",
                                            color: setMobileBackColor(),
                                            padding: "3px",
                                            borderRadius: 20,
                                        }}
                                    >
                                        {basketItems.items?.length || 0}
                                    </span>
                                }
                                sx={{ color: setMobileCardColor() }}
                            >
                                <ShoppingCart style={{ color: setMobileTextColor() }} fontSize="medium" />

                            </Badge>
                        </div>
                        <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Cart")}</span>
                    </button>
                    {localStorage.getItem("mobileLoginToken") ? (
                        <>
                            <button className="nav-item" onClick={() => handleProfile()}>
                                <PersonIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                                <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("My Profile")}</span>
                            </button>
                            <button className="nav-item" onClick={() => handleLogout()}>
                                <ExitToAppIcon style={{ color: setMobileTextColor() }} fontSize="medium" />
                                <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Logout")}</span>
                            </button>
                        </>

                    ) : (
                        <button className="nav-item" onClick={() => handleOpenLoginDialog()}>
                            <LoginRounded style={{ color: setMobileTextColor() }} fontSize="medium" />
                            <span style={{ color: setMobileTextColor() }} className="sub-font" >{t("Login")}</span>
                        </button>
                    )}


                </div>
                <Dialog sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: setMobileCardColor(),
                        width: "80%"
                    },
                }} open={isDialogOpen} onClose={handleCloseDialog}>
                    <DialogTitle sx={{ color: setMobileTextColor() }}>{t("Helper")}</DialogTitle>
                    <DialogContent>
                        <div className="notification-buttons">
                            <Badge
                                sx={{ backgroundColor: setMobileTextColor(), color: setMobileBackColor() }}
                                onClick={() =>
                                    handleSendNotification(
                                        "call waiter",
                                        "please call waiter for this table"
                                    )
                                }
                                className="badge-style"
                            >
                                {t("Call Waiter")}
                            </Badge>

                            {detailsData?.notification_buttons_settings?.notification_1_active && (
                                <Badge
                                    sx={{ backgroundColor: setMobileTextColor(), color: setMobileBackColor() }}
                                    onClick={() =>
                                        handleSendNotification(
                                            detailsData.notification_buttons_settings.notification_1_title,
                                            detailsData.notification_buttons_settings.notification_1_body
                                        )
                                    }
                                    className="badge-style"
                                >
                                    {t(detailsData.notification_buttons_settings.notification_1_button) || ""}
                                </Badge>
                            )}

                            {detailsData?.notification_buttons_settings?.notification_2_active && (
                                <Badge
                                    onClick={() =>
                                        handleSendNotification(
                                            detailsData.notification_buttons_settings.notification_2_title,
                                            detailsData.notification_buttons_settings.notification_2_body
                                        )
                                    }
                                    className="badge-style"
                                >
                                    {t(detailsData.notification_buttons_settings.notification_2_button) || ""}
                                </Badge>
                            )}
                        </div>
                        {/* <Button onClick={handleCloseDialog}>{t("Close")}</Button> */}
                    </DialogContent>
                </Dialog>

                <LoginComponent
                    open={loginDialogOpen}
                    handleCloseDialog={handleCloseLoginDialog}
                    tableQr={qr}
                    tableName={qrName}
                    onVerificationSuccess={handleVerificationSuccess}
                    is_from={2}
                />
            </div>




    );
};

export default BottomNavBar;
